var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessComplaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 165,
    viewBox: "0 0 210 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_292807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.1 140.3C171.1 122.6 176.9 107.7 177.4 99.6001C178.2 87.5001 166.5 79.0001 160.5 76.3001C126.9 63.1001 99.3998 49.0001 89.8998 43.6001C75.8998 35.7001 56.6998 36.8001 44.2998 47.2001C39.2998 51.4001 35.0998 58.3001 33.4998 64.7001C29.9998 78.8001 33.2998 94.9001 37.6998 108.4C42.6998 124 51.0998 140.3 65.0998 149.6C79.3998 159.1 97.9998 155.9 113.4 150.8C121.6 148.1 129.3 144.4 137.1 140.3Z",
    fill: "#E0FFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1 84.5H104.7V110.2H114.1V84.5Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 90.5C124.964 90.5 137.5 77.964 137.5 62.5C137.5 47.036 124.964 34.5 109.5 34.5C94.036 34.5 81.5 47.036 81.5 62.5C81.5 77.964 94.036 90.5 109.5 90.5Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 90C122.7 90 135 77.7 135 62.5C135 47.3 122.7 35 107.5 35C92.3 35 80 47.3 80 62.5C80 77.7 92.3 90 107.5 90Z",
    fill: "#A9F1C4",
    stroke: "#1A1F45",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1 75L91.7998 63.7L95.9998 59.4L103.1 66.5L119.8 49.9L124 54.1L103.1 75Z",
    fill: "#0D9943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.221 49.5321L144.207 55.0664L144.45 56.0362L166.465 50.5019L166.221 49.5321Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.538 9.75061L123.963 31.1499L124.906 31.4836L132.481 10.0843L131.538 9.75061Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.352 24.2297L141.283 37.97L141.889 38.766L159.958 25.0257L159.352 24.2297Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7698 64.0695L46.3672 67.7288L46.5284 68.7157L68.931 65.0564L68.7698 64.0695Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7657 81.4976L50.6069 93.6716L51.1432 94.5156L70.302 82.3416L69.7657 81.4976Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1447 90.1403L76.79 110.822L77.7011 111.234L87.0558 90.5524L86.1447 90.1403Z",
    fill: "#1A1F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 121.4C119.8 121.5 119.7 121.8 119.8 122.1C119.9 122.2 120 122.3 120.2 122.4C120.2 122.4 120.3 122.4 120.4 122.4C120.6 122.4 120.8 122.5 121.1 122.6C121.6 122.8 122.3 123.1 122.9 123.6C123.5 124.1 124 124.7 124.1 125.6C124.3 126.5 124.2 127.6 123.5 129.1C123.5 129.1 123.5 129.2 123.4 129.2C123.3 129.3 123.2 129.5 123.1 129.7C122.8 130.1 122.2 130.8 121.4 131.5C119.8 133.1 117.1 135.2 112.6 137.6H112.5C112.4 137.6 112.3 137.7 112.2 137.8C111.9 138 111.6 138.2 111.2 138.7C110.4 139.5 109.6 140.7 109 142.7H79.3999C79.3999 142.4 79.4999 141.9 79.5999 141.3C79.7999 140.1 80.0999 138.3 80.5999 136.1C81.4999 131.8 82.8999 126.1 84.8999 120.4C86.8999 114.7 89.5999 109 92.9999 104.7C96.2999 100.6 100.2 97.8 104.8 97.5V104C102.9 105.7 101 107.4 99.9999 109C99.8999 109.2 99.8999 109.5 100.1 109.6C100.3 109.8 100.6 109.8 100.7 109.6L100.8 109.5C100.9 109.5 100.9 109.4 101.1 109.3C101.3 109.1 101.7 108.9 102.1 108.5C103 107.8 104.2 107 105.6 106C107.9 104.4 110.7 102.7 113.5 101.4C115.6 100.5 117.6 99.8 119.3 99.8C120.9 99.8 122.2 100.3 123 101.5C123 101.5 123 101.6 123.1 101.6C123.1 101.7 123.2 101.9 123.3 102.2C123.4 102.7 123.5 103.4 123.4 104.2C123.2 105.8 122.3 108 119.1 110C118.9 110.1 118.8 110.3 118.9 110.5C118.9 110.7 119.1 110.9 119.3 110.9H119.4C119.5 110.9 119.6 111 119.8 111.1C120.1 111.3 120.6 111.5 121.1 111.9C122.1 112.6 123.1 113.8 123.4 115.6C123.4 115.6 123.4 115.6 123.4 115.7C123.4 115.8 123.4 115.9 123.4 116.1C123.4 116.4 123.4 116.9 123.2 117.4C123 118.8 122.2 120.2 120 121.4Z",
    fill: "white",
    stroke: "#1A1F45",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2 142.1L108.5 152.5C98.8998 155.3 88.2998 157 78.4998 155.2L78.2998 149.6L79.0998 139.7L109.2 142.1Z",
    fill: "#096B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4998 155.1L78.2998 149.5L79.0998 139.6L109.2 142.1L108.5 152.4",
    stroke: "#1A1F45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_292807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 147,
    fill: "white",
    transform: "translate(32 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessComplaint);
export default __webpack_public_path__ + "static/media/success-complaint.cb63218b0d60529030f8a594f37adac5.svg";
export { ForwardRef as ReactComponent };